<template>
  <div class="h-full d-flex align-center justify-center pt-5 pb-2">
    <div v-if="carregando_dados" class="position-absolute text-center z-1">
      <v-progress-circular color="red" indeterminate size="40" width="3" />
      <p class="ma-0 font-14 mt-2 text-gray-900">Carregando... aguarde</p>
    </div>

    <div class="w-full h-full">
      <Configuracao
        class="position-sticky pl-5 mb-n6 mt-n1 z-2"
        :qtde_meses_pai="qtde_meses_selecionado"
        @update:qtde-meses="mudouQtdeMeses"
      />

      <v-layout>
        <v-flex xs12>
          <div v-if="props.exibirFilialDropdown" id="select-filial-chart" style="position: absolute; left: auto; right: 0; z-index: 4" class="mr-3">
            <v-select
              v-model="selects.filial.value"
              :items="selects.filial.items"
              hide-details
              item-value="filial"
              item-text="descricao"
              outlined
              dense
            >
              <template  v-slot:label>
                <p class="mt-n2 font-10">Filial</p>
              </template>
            </v-select>
          </div>
        </v-flex>
      </v-layout>

      <div :id="ID_DOM" style="width: 100%; height: 100%;" />
    </div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {formatarValor, logout, nomeMeses} from "@/helpers";
import formatarValoresBi from "@/helpers/formatarValoresBi";
import {converterEmbalagemValor} from "@/components/compra/ProdutosGerais/ConversorEmbalagem";
import api from "@/api/api";
import store from "@/store";
import Configuracao from "@/components/produto/detalhes/grafico/Configuracao.vue";
import { FILIAL_TODAS } from "@/components/utils/FilialGrupo.js";

let myChart;

const props = defineProps({
  produto: {
    type: Object,
    required: true
  },
  atualizar_detalhes_count: Number,
  ativar_filtro_revenda_direta: Boolean,
  qtde_meses_pai: {
    type: Number,
    required: false,
    default: 0
  },
  exibirFilialDropdown: {
    type: Boolean,
    default: false
  }
});
const selects = ref({ filial: { value: FILIAL_TODAS.ID, items: [] } });

const emit = defineEmits(['click:bar']);

const now = new Date();

const ID_DOM = `grafico-movimentacoes-estoque-${now.getHours()}-${now.getMinutes()}-${now.getSeconds()}-${now.getMilliseconds()}`;

const carregando_dados = ref(true);

const dados_de_cadastro_produto = ref({});
const produto_possui_heranca = ref(false);

const serie_padrao = new Array(31).fill(0);

const margem_lucro_valor = ref([]);
const avarias = ref({
  valores: [],
  volumes: [],
});

const info_series = {
  entradas: {
    index: 'entradas',
    name: 'Entradas',
    visao_heranca: true,
  },
  entradas_heranca: {
    index: 'entradas_heranca',
    name: 'Entradas Herança',
    visao_heranca: true,
  },
  vendas_desconsideradas: {
    index: 'vendas_desconsideradas',
    name: 'Vendas desconsideradas',
  },
  saidas: {
    index: 'saidas',
    name: 'Vendas',
    visao_heranca: true,
  },
  saidas_heranca: {
    index: 'saidas_heranca',
    name: 'Vendas Herança',
    visao_heranca: true,
  },
  estoque: {
    index: 'estoque',
    name: 'Estoque Médio',
  },
  mercado: {
    index: 'mercado',
    name: 'Mercado',
  },
  margem_lucro: {
    index: 'margem_lucro',
    name: 'Margem de Lucro',
  },
  avaria_em_taxa: {
    index: 'avaria_em_taxa',
    name: 'Taxa de Avaria',
  }
};

const qtde_meses_selecionado = ref(12);

function mudouQtdeMeses({ qtde_meses }) {
  emit('update:qtde-meses', qtde_meses);

  buscarDadosGrafico();
  qtde_meses_selecionado.value = qtde_meses;
}

function somaValoresIndexSeries(data_index, ...index_series) {
  const series = option.value.series.filter(item => index_series.includes(item.index));
  return series.reduce((a, b) => a + Number(b.data[data_index] || 0), 0);
}

function formataSomaValoresIndexSeries(data_index, ...index_series) {
  const valor = somaValoresIndexSeries(data_index, ...index_series);
  return Number(valor) > 0 ? formatarValoresBi(Number(valor || 0), 1) : '';
}

const label = {
  show: true,
  position: 'top',
  rotate: 90,
  offset: [15, 0],
  fontSize: 11,
  align: 'center',
  color: 'black',
  verticalAlign: 'center',
  textBorderColor: 'none',
  textBorderWidth: 0,
  formatter: function (f) {
    if (f.seriesName === info_series.saidas.name) {
      const object_venda = typeof option.value.series[3].data[f.dataIndex];
      return object_venda === 'object' ? formatarValoresBi(Number(option.value.series[3].data[f.dataIndex].value || 0), 1) : '';
    }

    if (f.seriesName === info_series.saidas_heranca.name) {
      return formataSomaValoresIndexSeries(f.dataIndex, info_series.saidas.index, info_series.saidas_heranca.index);
    }

    if (f.seriesName === info_series.entradas_heranca.name) {
      return formataSomaValoresIndexSeries(f.dataIndex, info_series.entradas.index, info_series.entradas_heranca.index);
    }

    return Number(f.value) <= 0 ? '' : formatarValoresBi(Number(f.value || 0), 1);
  }
};

const series = [
  {
    index: info_series.entradas.index,
    name: info_series.entradas.name,
    type: "bar",
    yAxisIndex: 0,
    z: 2,
    color: "#043554",
    stack: 'colunaEntrada',
    label: { ...label, show: false },
    data: serie_padrao,
  },
  {
    index: info_series.entradas_heranca.index,
    name: info_series.entradas_heranca.name,
    type: "bar",
    yAxisIndex: 0,
    z: 2,
    color: "#829AAA",
    stack: 'colunaEntrada',
    label,
    data: serie_padrao,
  },
  {
    index: info_series.vendas_desconsideradas.index,
    name: info_series.vendas_desconsideradas.name,
    type: "bar",
    yAxisIndex: 0,
    z: 2,
    color: "#ffd1d1",
    stack: 'colunaSaidas',
    itemStyle: {
      borderColor: '#ff0000',
      borderWidth: 1,
      borderType: 'dashed',
    },
    data: serie_padrao,
  },
  {
    index: info_series.saidas.index,
    name: info_series.saidas.name,
    type: "bar",
    yAxisIndex: 0,
    z: 2,
    color: "#D60E2B",
    label: { ...label, show: true },
    stack: 'colunaSaidas',
    data: serie_padrao,
  },
  {
    index: info_series.saidas_heranca.index,
    name: info_series.saidas_heranca.name,
    type: "bar",
    yAxisIndex: 0,
    z: 2,
    label,
    color: "#EB8795",
    stack: 'colunaSaidas',
    data: serie_padrao,
  },
  {
    index: info_series.estoque.index,
    name: info_series.estoque.name,
    type: "line",
    yAxisIndex: 0,
    smooth: 0.3,
    color: '#888888',
    lineStyle: {
      color: '#888888',
      width: 1
    },
    areaStyle: {
      color: '#d7d6d6',
    },
    z: 1,
    showSymbol: false,
    data: serie_padrao,
  },
  {
    index: info_series.margem_lucro.index,
    name: info_series.margem_lucro.name,
    type: "line",
    yAxisIndex: 1,
    smooth: 0.3,
    color: "rgb(225,148,0)",
    lineStyle: {
      width: 2
    },
    z: 2,
    stack: 'Total',
    showSymbol: false,
    data: serie_padrao
  },
  {
    index: info_series.avaria_em_taxa.index,
    name: info_series.avaria_em_taxa.name,
    type: "line",
    yAxisIndex: 1,
    smooth: 0.3,
    color: "#993399",
    lineStyle: {
      width: 2
    },
    z: 2,
    showSymbol: false,
    data: serie_padrao
  }
];

const series_com_mercado = [
  {
    index: info_series.mercado.index,
    name: info_series.mercado.name,
    type: "line",
    smooth: 0.3,
    color: '#ffc900',
    lineStyle: {
      width: 2
    },
    z: 3,
    showSymbol: false,
    data: serie_padrao,
  }
];

const option = ref({
  grid: {
    top: '35px',
    bottom: '0%',
    left: '2%',
    right: '2%',
    containLabel: true,
    shadowOffsetX: {
      show: true,
    }
  },
  legend: {
    show: true,
    data: ['Entradas', 'Vendas', 'Estoque Médio'],
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        show: false,
        formatter: label => {
          if (label.axisDimension === 'y') {
            return formatarValor(label.value);
          }

          return label.value;
        },
        confine: true
      }
    },
    formatter: function (params) {
      var tooltipText = '';

      const y_value = params[0].axisValue;

      if (label.axisDim === 'y') {
        tooltipText += formatarValor(y_value) + '<br>';
      } else {
        tooltipText += y_value + '<br>';
      }

      params.forEach(function (item) {
        if (item.seriesName === 'Vendas' && typeof item.data == 'object') {
          tooltipText += item.marker + 'Projeção de Vendas: ' + formatarValor(item.data.value) + '<br>';
          return;
        }

        const formatar_tooltip_heranca = produto_possui_heranca.value
          && Object.values(info_series).filter(serie => serie.visao_heranca).some(serie => serie.name === item.seriesName);

        if (formatar_tooltip_heranca) {
          if (item.seriesName.includes('Herança')) {
            tooltipText += `<span class="pl-3 font-13">${item.marker}Produto Herança: ${formatarValor(item.data)}</span><br>`;
            return;
          }

          tooltipText += `
            ${item.seriesName}
            <br>
            <span class="pl-3 font-13">${item.marker}Produto Principal: ${formatarValor(item.data)}</span>
            <br>
          `;
          return;
        }

        if (item.seriesName.includes('Herança') && !produto_possui_heranca.value) {
          return;
        }

        if (item.seriesName === info_series.margem_lucro.name) {
          if (margem_lucro_valor.value.every(valor => Number(valor || 0) === 0)) return;

          tooltipText += `${info_series.margem_lucro.name}: <br>
            <span class="pl-3 font-13">${item.marker} Em percentual: ${formatarValor(item.data)}%</span> <br>
            <span class="pl-3 font-13">${item.marker} Em valor: R$ ${formatarValor(margem_lucro_valor.value[item.dataIndex])}</span> <br>
          `;
          return;
        }

        if (item.seriesName === info_series.avaria_em_taxa.name) {
          if (avarias.value.valores.every(valor => Number(valor || 0) === 0)) return;

          tooltipText += `${info_series.avaria_em_taxa.name}: <br>
            <span class="pl-3 font-13">${item.marker} Em percentual: ${formatarValor(item.data)}%</span> <br>
            <span class="pl-3 font-13">${item.marker} Em volume: ${formatarValor(avarias.value.volumes[item.dataIndex])}</span> <br>
            <span class="pl-3 font-13">${item.marker} Em valor: R$ ${formatarValor(avarias.value.valores[item.dataIndex])}</span> <br>
          `;
          return;
        }

        tooltipText += item.marker + item.seriesName + ': ' + formatarValor(item.data) + '<br>';
      });

      return tooltipText;
    },
    valueFormatter: valor => formatarValor(valor)
  },
  xAxis: {
    type: 'category',
    axisLabel: {
      fontSize: 11,
      color: 'black',
      interval: 0,
    },
    boundaryGap: true,
    splitLine: {
      show: true
    },
    data: ['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-',]
  },
  yAxis: [
    {
      type: 'value',
      position: 'left',
      splitLine: {
        show: true
      },
      axisLabel: {
        formatter: valor => formatarValor(valor)
      },
      max: 1
    },
    {
      index: 'margem_lucro',
      type: 'value',
      position: 'right',
      show: true,
      min: 0,
      max: 100,
      splitLine: {
        show: false
      }
    }
  ],
  series: series
});

const EMBALAGEM_MASTER_ATIVO = computed(() => store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"]);
const VISAO_VERTICAL_ATIVA = computed(() => store.getters["CompraProdutosGerais/getVisaoVertical"]);

watch(EMBALAGEM_MASTER_ATIVO, converterEmbalagemSeries);
watch(VISAO_VERTICAL_ATIVA, atualizarGrafico);

watch(() => props.produto, buscarFiliais);

onMounted(() => {
  if (props.qtde_meses_pai !== 0){
    qtde_meses_selecionado.value = props.qtde_meses_pai;
  }
  buscarFiliais();
  iniciarGrafico();
});

async function iniciarGrafico() {
  const chartDom = document.getElementById(ID_DOM);

  myChart = echarts.init(chartDom);
  myChart.setOption(option.value);

  await nextTick();
  myChart.resize();

  myChart.on('click', function (params) {
    if (option.value.xAxis.data[12] === params.name) return;

    emit('click:bar', { data: params.name, qtde_venda: params.value });
  });

  window.addEventListener('resize', () => myChart.resize());
}

function atualizarGrafico() {
  if (props.qtde_meses_pai !== 0){
    qtde_meses_selecionado.value = props.qtde_meses_pai;
  }

  option.value.xAxis.axisLabel.fontSize = qtde_meses_selecionado.value !== 12 ? 11 : 10;
  option.value.xAxis.axisLabel.rotate = qtde_meses_selecionado.value !== 12 ? 45 : 0;

  myChart.setOption(option.value);
  myChart.resize();
}

watch(() => selects.value.filial.value, buscarDadosGrafico);
watch(() => props.produto, buscarDadosGrafico);
watch(() => props.atualizar_detalhes_count, buscarDadosGrafico);

const maior_valor_percentual_computed = computed(() => {
  const serie_margem_lucro = option.value.series.find(item => item.index === info_series.margem_lucro.index);
  const serie_avaria_em_taxa = option.value.series.find(item => item.index === info_series.avaria_em_taxa.index);

  const maior_valor = Math.max(...serie_margem_lucro.data, ...serie_avaria_em_taxa.data);

  return Math.ceil(maior_valor + (maior_valor * 0.2));
});

function buscarDadosGrafico() {
  carregando_dados.value = true;

  const params = {
    ...props.produto,
    ativar_filtro_revenda_direta: props.ativar_filtro_revenda_direta ? 'S' : 'N',
  }

  if (selects.value.filial.value !== FILIAL_TODAS.ID && props.exibirFilialDropdown) {
    params.filial = selects.value.filial.value;
  }

  api.get('compras_analiseproduto_grupo', { params })
    .then(response => {
      const { data, cadastro_produto, possui_heranca } = response.data;
      produto_possui_heranca.value = possui_heranca;
      dados_de_cadastro_produto.value = cadastro_produto;

      if (data.ativar_mercado) {
        option.value.series = [...series, ...series_com_mercado];
      } else {
        option.value.series = series;
      }

      option.value.xAxis.data = data.referencia.map(item => {
        const [mes, ano] = item.split('/');
        return `${(nomeMeses[Number(mes) - 1] || '').substring(0, 3)}/${ano}`;
      });

      let arrayValoesGrafico = [];

      for (const serie of option.value.series) {
        arrayValoesGrafico.push(data[serie.index]);
        serie.data = data[serie.index]
      }

      margem_lucro_valor.value = data.margem_lucro_valor;

      avarias.value.volumes = data.avaria_em_volume;
      avarias.value.valores = data.avaria_em_valor;

      const max_entradas = maxSomaArrays(arrayValoesGrafico[0], arrayValoesGrafico[1]);
      const max_vendas = maxSomaArrays(arrayValoesGrafico[2], arrayValoesGrafico[3]);
      const max_estoque = Math.max(...arrayValoesGrafico[5].map(Number));
      const max_heranca = Math.max(...arrayValoesGrafico[4].map(Number));
      const max = Math.max(...[max_entradas, max_vendas, max_estoque, max_heranca]);
      option.value.yAxis[0].max = max + (max * 0.15);

      setConfigYAxisPecentuais()

      if (EMBALAGEM_MASTER_ATIVO.value) {
        converterEmbalagemSeries();
      }
    })
    .catch(logout)
    .finally(() => {
      criacaoDestruicaoGrafico();
      carregando_dados.value = false;
    });
}

function setConfigYAxisPecentuais() {
  const y_axis_margem_lucratividade = option.value.yAxis.find(item => item.index === 'margem_lucro');

  if (maior_valor_percentual_computed.value > 0) {
    y_axis_margem_lucratividade.max = maior_valor_percentual_computed.value;
    y_axis_margem_lucratividade.show = true;
    option.value.grid.right = '2%';
  } else {
    y_axis_margem_lucratividade.max = 100;
    y_axis_margem_lucratividade.show = false;
    option.value.grid.right = '-20px';
  }
}

function buscarFiliais() {
  if (!props.exibirFilialDropdown) return;

  const params = { grupo: props.produto.grupo };

  api.get('/getFiliaisDrpGrupo', {params})
    .then((response) => {
      const { filiais } = response.data;

      selects.value.filial.items = filiais.map(item => {
        if (item.nome_fantasia) {
          item.descricao = item.descricao + ' - ' + item.nome_fantasia
        }
        return item;
      });

      filiais.forEach((filial) => selects.value.filial.items.push(filial));
      selects.value.filial.items.push({filial: FILIAL_TODAS.ID, descricao: FILIAL_TODAS.DESCRICAO})
      selects.value.filial.value = filialCompra > 0 ? filialCompra : FILIAL_TODAS.ID;
    })
    .catch(() => logout);
}

function maxSomaArrays(array1, array2) {
  const resultado = array1.map((value, index) => {
    return (parseInt(value) + parseInt(array2[index])).toString();
  });

  return Math.max(...resultado.map(Number));
}

function converterEmbalagemSeries() {
  for (const serie of option.value.series) {
    serie.data = serie.data.map(valor => {
      if (valor != null && typeof valor == 'object') {
        let projecao_vendas_grafico = converterEmbalagemValor(dados_de_cadastro_produto.value, Number(valor.value));
        const prg = { ...valor, value: projecao_vendas_grafico };
        return prg;
      }

      return converterEmbalagemValor(dados_de_cadastro_produto.value, Number(valor));
    });
  }

  option.value.yAxis[0].max= EMBALAGEM_MASTER_ATIVO.value
    ? option.value.yAxis[0].max / dados_de_cadastro_produto.value.multiplo_compra
    : option.value.yAxis[0].max * dados_de_cadastro_produto.value.multiplo_compra;

  setConfigYAxisPecentuais();
  atualizarGrafico();
}

function criacaoDestruicaoGrafico() {
  myChart.dispose();
  iniciarGrafico();
  atualizarGrafico();
}
</script>
